import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { OrdersCreateControllerModule } from './controllers/OrdersCreateController';

export const OrdersCreateView = angular
  .module('acme.view.application.orders.create', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.directive.numeric',
    OrdersCreateControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.orders.create',
      url: '/create?customerId&accountId&eventTemplateId',
      views: {
        'subview-main': {
          controller: 'OrdersCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/orders/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: 'Create Order',
      },
    });
  }).name;
